<template>
  <div class="bg-white shadow-sm py-3 h-100" style="border-radius: 20px;">
    <div class="d-flex align-items-center">
      <div class="px-4 ml-auto">تسویه‌های اخیر</div>
      <div class="px-4">
        <router-link class="text-success" to="/settlements">مشاهده کل</router-link>
      </div>
    </div>
    <hr>
    <div v-if="status == 'ok' && settlements.length > 0">
      <div v-for="(settlement , index) in settlements" :key="index" class="settlement-row" :class="'st-' + statusVariantForCommonAccess(settlement.status)">
        <div class="px-3 my-4 d-flex align-items-center">
          <div class="ml-auto d-flex align-items-center">
            <div class="bg-bank border border-dark rounded-circle p-2" style="border-color: #a0a0a0 !important;">
              <img :src="require('@/assets/new/banks_logos/' + getBankNickname(settlement.sheba_number) + '.png')" alt="bank" width="24" height="24">
            </div>
            <div>
              <div class="pr-3" dir="ltr">{{ settlement.created_at }}</div>
              <div class="pr-3 mt-2">{{settlement.gateway_farsi_name}}</div>
            </div>
          </div>
          <div>
            <div :class="'pl-3 text-' + statusVariantForCommonAccess(settlement.status)"><b>{{ settlement.amount }} ریال</b></div>
            <div class="pl-3 mt-2 text-left"><small>
              <b>
                {{ statusStrForCommonAccess.get(settlement.status) }}
              </b>
            </small></div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div style="filter: blur(5px);">
        <div class="px-4 my-4 d-flex align-items-center">
          <div class="ml-auto d-flex align-items-center">
            <div class="border border-dark rounded-circle p-2" style="border-color: #a0a0a0 !important;">
              <div>...</div>
            </div>
            <div>
              <div class="px-4" dir="ltr">1399/12/19</div>
              <div class="px-4 mt-2">درگاه تلفنی اول</div>
            </div>
          </div>
          <div>
            <div :class="'px-4 text-success'"><b>12,7000 ریال</b></div>
            <div class="px-4 mt-2 text-left"><small>
              <b>
                تایید شده
              </b>
            </small></div>
          </div>
        </div>
        <div class="px-4 my-4 d-flex align-items-center">
          <div class="ml-auto d-flex align-items-center">
            <div class="border border-dark rounded-circle p-2" style="border-color: #a0a0a0 !important;">
              <div>...</div>
            </div>
            <div>
              <div class="px-4" dir="ltr">1399/12/19</div>
              <div class="px-4 mt-2">درگاه تلفنی اول</div>
            </div>
          </div>
          <div>
            <div :class="'px-4 text-success'"><b>12,7000 ریال</b></div>
            <div class="px-4 mt-2 text-left"><small>
              <b>
                تایید شده
              </b>
            </small></div>
          </div>
        </div>
        <div class="px-4 my-4 d-flex align-items-center">
          <div class="ml-auto d-flex align-items-center">
            <div class="border border-dark rounded-circle p-2" style="border-color: #a0a0a0 !important;">
              <div>...</div>
            </div>
            <div>
              <div class="px-4" dir="ltr">1399/12/19</div>
              <div class="px-4 mt-2">درگاه تلفنی اول</div>
            </div>
          </div>
          <div>
            <div :class="'px-4 text-success'"><b>12,7000 ریال</b></div>
            <div class="px-4 mt-2 text-left"><small>
              <b>
                تایید شده
              </b>
            </small></div>
          </div>
        </div>
        <div class="px-4 my-4 d-flex align-items-center">
          <div class="ml-auto d-flex align-items-center">
            <div class="border border-dark rounded-circle p-2" style="border-color: #a0a0a0 !important;">
              <div>...</div>
            </div>
            <div>
              <div class="px-4" dir="ltr">1399/12/19</div>
              <div class="px-4 mt-2">درگاه تلفنی اول</div>
            </div>
          </div>
          <div>
            <div :class="'px-4 text-success'"><b>12,7000 ریال</b></div>
            <div class="px-4 mt-2 text-left"><small>
              <b>
                تایید شده
              </b>
            </small></div>
          </div>
        </div>
        <div class="px-4 my-4 d-flex align-items-center">
          <div class="ml-auto d-flex align-items-center">
            <div class="border border-dark rounded-circle p-2" style="border-color: #a0a0a0 !important;">
              <div>...</div>
            </div>
            <div>
              <div class="px-4" dir="ltr">1399/12/19</div>
              <div class="px-4 mt-2">درگاه تلفنی اول</div>
            </div>
          </div>
          <div>
            <div :class="'px-4 text-success'"><b>12,7000 ریال</b></div>
            <div class="px-4 mt-2 text-left"><small>
              <b>
                تایید شده
              </b>
            </small></div>
          </div>
        </div>

      </div>
      <div class="locked-overlay" v-if="status == 'loading'">
        <div style="position: absolute; width: 100%; text-align: center; top: 30%;">
          <div class="btn btn-success mt-5">
            <div class="d-flex justify-content-center align-items-center"><div class="px-2">لطفا صبر کنید</div><div class="spinner-border spinner-border-sm text-white" role="status"></div></div>
          </div>
        </div>
      </div>
      <div class="locked-overlay" v-else-if="status == 'ok' && settlements.length == 0">
        <div style="position: absolute; width: 100%; text-align: center; top: 30%;">
          <div>
            <div class="btn">
              <img src="@/assets/new/image/not-found_new.png" width="200">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ApiService} from "@/common/api.service";
import {statusStrForCommonAccess, statusVariantForCommonAccess} from "@/constants/settlementStatus";
import IranSheba from "iran-sheba";

export default {
  name: "recent-settlements",
  data() {
    return {
      settlements: null,
      statusVariantForCommonAccess,
      statusStrForCommonAccess,
      status: 'loading'
    }
  },
  created() {
    ApiService.query('settlement?page=1&perpage=6', '').then(json => {
      this.settlements = json.data.data.data;
      this.status = 'ok';
    })
  },
  methods : {
    getBankNickname(sheba) {
      const bank = IranSheba.recognize( sheba.split("-").join(""));
      if (bank) {
        return bank.nickname;
      }
      return "central-bank"; // default value for when this function failed to recognize the bank name
    },
  }
}
</script>

<style scoped>
.settlement-row {
  background: rgba(128, 128, 128, 0.1);
  border: 1px solid rgba(128, 128, 128, 0.35);
  border-inline-start: 4px solid #b5b5c3;
  border-radius: 12px;
  margin: 0 16px 14px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}
.settlement-row > div {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}
.settlement-row.st-success { border-inline-start-color: #1bc5bd; }
.settlement-row.st-warning { border-inline-start-color: #ffa800; }
.settlement-row.st-danger { border-inline-start-color: #f64e60; }

</style>